import { render, staticRenderFns } from "./itsoTeamRank.vue?vue&type=template&id=86ff5dd6&scoped=true&"
import script from "./itsoTeamRank.vue?vue&type=script&lang=js&"
export * from "./itsoTeamRank.vue?vue&type=script&lang=js&"
import style0 from "./itsoTeamRank.vue?vue&type=style&index=0&id=86ff5dd6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86ff5dd6",
  null
  
)

export default component.exports